/* eslint-disable no-case-declarations */
import { createAction } from 'redux-actions';

// Types
export const SET_VERTICAL = 'amp/SET_VERTICAL';

// Actions
export const setVertical = createAction(SET_VERTICAL);

// Reducer
const INITIAL_STATE = {
  vertical: null,
};

export default function (state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case SET_VERTICAL:
      if (!payload) {
        return {
          ...state,
          vertical: 'mach',
        };
      }

      return {
        ...state,
        vertical: payload,
      };
    default:
      return state;
  }
}
/* eslint-enable no-case-declarations */
